
<div *ngIf="privilegesView==='AccessDenied'" class=" outside-container  mt-4" >
  <div class="box-container">
    <div class="container">
      <div *ngIf="privilegesView==='AccessDenied'" class="  d-flex justify-content-center" >

  <img src="../../../assets/images/AccessDeniedError.png" alt="">
</div>

 </div>
</div>
</div>

<div *ngIf="privilegesView==='VAMD'" class="outside-container mt-4">
    <div class="box-container ">
        <div class="container">
            <div class="title ">

              <div class="row">
                <div class=" col-md-2  " >
                  <div *ngIf="!ShowEdit" class="pointer d-flex justify-content-start "  (click)="backClick()" style="padding-left:20px;">⬅️</div>
                  <div *ngIf="ShowEdit" class="pointer d-flex justify-content-start "  (click)="back()" style="padding-left:20px;">⬅️</div>

                </div>  
               <div class="col-md-7 d-flex justify-content-center">Travel Policy</div>
               <div class=" col-md-3 row ">
                 <div class="d-flex justify-content-end">
                  <!-- <button *ngIf="showGroup" class="btn btn-outline-primary btn-sm " (click)="onAddGroup()"><img src="assets/images/Add_24.png"></button>
                  <button *ngIf="showSupplier" class="btn btn-outline-primary btn-sm " (click)="onAddSupplier()"><img src="assets/images/Add_24.png"></button>
                  <button  *ngIf="showSource" class="btn btn-outline-primary btn-sm " (click)="onAddSource()"><img src="assets/images/Add_24.png"></button>
                  <button  *ngIf="showCarrier" class="btn btn-outline-primary btn-sm " (click)="onAddCarrier()"><img src="assets/images/Add_24.png"></button> -->

               </div>
                </div>
              </div>
            
            </div> 
            </div>
            </div>
          </div>
            <div *ngIf="privilegesView==='VAMD'"  class="outside-container ">
                <div class="box-container ">
                    <div *ngIf="!ShowEdit" class="container ">
                      <div class="col-md-12 row d-flex justify-content-center " style="padding-left: 20px; ">
                     
                        
                       <div class="col-md-12" style="height:70vh; overflow-y: auto;">
                         <div *ngIf="showGroup" class="col-md-12 card" style="min-height: 100%;" >
    
                          <div class=" row mt-3 " style="padding: 10px;">
                           
                            
                            <div class="col-md-12 " >
                              <div class="row">
                              <mat-form-field class=" col-md-3 mt-1 form-group " >
                              <input matInput type="text"  [(ngModel)]="search.searchText"    placeholder="Search..." autocomplete="off" (input)="searchUser()"  >
                              
                              </mat-form-field>
                              <div  class="  col-md-1 pt-3">
                                  <button  class="btn btn-outline-primary btn-sm " (click)="onAddGroup()"><img src="assets/images/Add_24.png"></button>
                                 
                               </div>
                              <mat-paginator  class="col-md-8 mt-2 " style="background-color: transparent;" color="primary"
                              [pageSize]="10"
                              [pageSizeOptions]="[5, 10, 25, 100]"
                              [length]="totalElements"
                              (page)="nextPage($event)"
                              aria-label="Select page">
                              </mat-paginator>
                              
                              </div>
                              
                              <table mat-table
                              [dataSource]="groupData" multiTemplateDataRows style="background-color: transparent;">
                             
                              <!-- <ng-container matColumnDef="code">
                               <th mat-header-cell *matHeaderCellDef> Code </th>
                               <td mat-cell *matCellDef="let element;"> {{element.code}} </td>
                              </ng-container> -->
                               <ng-container matColumnDef="name">
                                 <th mat-header-cell *matHeaderCellDef>Policy</th>
                                 <td mat-cell *matCellDef="let element" > {{element.name}} </td>
                               </ng-container>
                               <ng-container matColumnDef="source">
                                  <th mat-header-cell *matHeaderCellDef>Type</th>
                                  <!-- <td mat-cell *matCellDef="let element" > {{sourceCodeToName(element.source)}} </td> -->
                                  <td mat-cell *matCellDef="let element" > {{'-'}} </td>

                                </ng-container>
    
                              <ng-container matColumnDef="status">
                               <th mat-header-cell *matHeaderCellDef> Status </th>
                               <td mat-cell *matCellDef="let element"> 
                                <span *ngIf="element.status==='A'">Active</span>
                                <span *ngIf="element.status==='I'">Inactive</span> </td>
                              </ng-container>
                              
                              <!-- email Column -->
                             
                              <ng-container matColumnDef="creationDate" >
                                <th mat-header-cell *matHeaderCellDef>Last Update</th>
                                <td mat-cell *matCellDef="let element"> {{formatDate(element.genTs)}} </td>
                               </ng-container>
  
                               <ng-container matColumnDef="delete" >
                                  <th mat-header-cell *matHeaderCellDef>Action </th>
                                  <td mat-cell *matCellDef="let element"> 
                                    <button mat-flat-button style="background-color: rgb(14, 115, 222);color: #fff;"  (click)="rowGroupClick(element)">Edit</button>
                                    <!-- <img (click)="deleteQueue(element.id)"  src="../../../assets/images/crosss.png" style="width: 25px;cursor: pointer;" alt=""> </td> -->
                                 </ng-container>
                             
                              <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                              <ng-container matColumnDef="expandedDetail">
                              <td mat-cell *matCellDef="let element" [attr.colspan]="columnsGroupDisplay.length">
                              <div class="example-element-detail row"
                               [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                              
                              </div>
                              </td>
                              </ng-container>
                              
                              <tr mat-header-row *matHeaderRowDef="columnsGroupDisplay"></tr>
                              <tr mat-row *matRowDef="let element; columns: columnsGroupDisplay;"
                              class="example-element-row">
                              </tr>
                              <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
                              <tr class="mat-row" *matNoDataRow>
                              <td  class="mat-cell" colspan="4">There is no data in this table</td>
                              </tr>
                              </table>
                              
                              
                              </div>
                              
                          
                        
                        </div> 
                          </div>
                          
                        </div>
                        </div>
                    </div>
    

                    


                    <div class="modal " id="myMod"  [style.display]="showGroupPopup ? 'block' : 'none'" >
                      <div class="modal-dialog" >
                          <div class="modal-content " >
                              <div class="modal-header title">
                                <h4 class="modal-title">Add Policy</h4>
                                <button type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>
                                </div>
                                <div class="modal-body">
                                <div class="col-md-12 mt-3 " *ngIf="showGroupPopup">
                                  <div class="col-md-12 d-flex justify-content-center" >
                                  <div class="col-md-12 row " >
                                      <div class=" col-md-12 ">
                                          <form [formGroup]="policyRefFg"  autocomplete="off"  class=" row" >
                                            
                                            <mat-form-field class="col-md-12" appearance="outline">
                                              <mat-label>Policy Name</mat-label>
                                              <input matInput type="text" maxlength="30" formControlName="name" name="name" autocomplete="off">
                                              <small *ngIf="policyRefFg.controls['name'].dirty && policyRefFg.controls['name'].invalid" class="warn">Please Enter Queue name!</small>
    
                                            </mat-form-field>
                                            
                                           
                                            
                                            <mat-form-field class="col-md-12" appearance="outline">
                                              <mat-label>Status</mat-label>
                                              <mat-select matNativeControl name="status" formControlName="status">
                                                <mat-option value="A">Active</mat-option>
                                                <mat-option value="I">Inactive</mat-option>
                                              </mat-select>  
                                            </mat-form-field> 
                                            <mat-form-field class="col-md-12" appearance="outline">
                                                <mat-label>Description </mat-label>
                                                <textarea matInput type="text" maxlength="200" formControlName="description" name="name" autocomplete="off"></textarea>
      
                                              </mat-form-field>
                                            
                                            
                                            </form>
                                      </div>
                                      </div>
                                      </div>                                      
                                </div>
                                  <div class="modal-footer">
                                    <div class="form-group form-inline ">
                                      <label for="userName" class="col-md-5 col-form-label control-label"> </label>
                                    </div>   
                                    <button *ngIf="action==='newQue'" class="btn btn-outline-success c-width-100px shadow "  (click)="AddQueue()" [disabled]="policyRefFg.invalid">Save</button>
                                    <button type="button" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal" (click)="closePopup()">Close</button>
                                  </div>
                                </div>
                                </div>
                        </div>
                    </div>






<div >
    
      <div *ngIf="ShowEdit" class="row col-md-12 d-flex justify-content-center ">
          <div class="  mb-4  col-md-11   ">


            <div class="alerts-container">
              <h1> Travel Policy - Default </h1>
              <div class="filters">
                <!-- <button *ngFor="let filter of filters" class="filter-button">{{ filter }}</button> -->
                <!-- <div class="col-md-3 pleft " >
                  <label  for="from">From</label>
                  <input  class="form-control font" type="datetime-local" [max]="maxDate" name="startDate" (change)="validateDates()"   [(ngModel)]="request.startDate">
                </div>
                <div class="col-md-3 pleft " >
                  <label  for="to">To </label>
                  <input  class="form-control font" type="datetime-local" [min]="request.startDate" [max]="maxSelectionDate" name="stopDate"  (change)="validateEndDates()"   [(ngModel)]="request.endDate">
                </div> -->
              </div>
            
              <div class="alert-list">
                <div  class="alert-item" >
                  <div class="alert-icon">
                   <mat-icon >flight</mat-icon>
                  </div>
                  <div class="alert-content">
                    <p class="alert-title"> Flight</p>
                    <p class="alert-info">All employees can book flights in the US and Canada</p>
                  </div>
                  <div class="alert-action">
                    <span class="arrow-icon">&rarr;</span>
                  </div>
                </div>
              </div>
              <div class="alert-list">
                <div  class="alert-item" >
                  <div class="alert-icon">
                   <mat-icon >hotel</mat-icon>
                  </div>
                  <div class="alert-content">
                    <p class="alert-title"> Hotel</p>
                    <p class="alert-info">All employees can book hotels in the US and Canada</p>
                  </div>
                  <div class="alert-action">
                    <span class="arrow-icon">&rarr;</span>
                  </div>
                </div>
              </div>
              <div class="alert-list">
                <div  class="alert-item" >
                  <div class="alert-icon">
                   <mat-icon >car</mat-icon>
                  </div>
                  <div class="alert-content">
                    <p class="alert-title"> Car Rentals</p>
                    <p class="alert-info">All employees can book car rentals in the US and Canada</p>
                  </div>
                  <div class="alert-action">
                    <span class="arrow-icon">&rarr;</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="alerts-container">
              <h1> Clauses </h1>
              <div class="filters">
                
              </div>
            
              <div class="alert-list">
                <div  class="alert-item" >
                  <div class="alert-icon">
                   <mat-icon >flight</mat-icon>
                  </div>
                  <div class="alert-content">
                    <p class="alert-title"> Advanced Booking</p>
                    <p class="alert-info">All employees can book flights in the US and Canada</p>
                  </div>
                  <div class="alert-action">
                    <span class="arrow-icon">&rarr;</span>
                  </div>
                </div>
              </div>
              <div class="alert-list">
                <div  class="alert-item" >
                  <div class="alert-icon">
                   <mat-icon >hotel</mat-icon>
                  </div>
                  <div class="alert-content">
                    <p class="alert-title"> Advanced Booking</p>
                    <p class="alert-info">Employees must book hotels at least 7 days in advance</p>
                  </div>
                  <div class="alert-action">
                    <span class="arrow-icon">&rarr;</span>
                  </div>
                </div>
              </div>
            </div>
            
            
            <div class="approval-container">
              <h3>Approval workflows</h3>
              <p class="subtitle">
                Each policy can have its own approval workflow. You can add and remove approvers as needed.
              </p>
            
              <button class="add-approver-btn" (click)="addApprovers()">
                <span class="plus-icon">＋</span> Add approver
              </button>
            </div>







            
                  
              <div   class="col-md-11 mleft d-flex justify-content-end">
              </div>
         
      </div>
  </div>    
  </div>
 
  


  <p-dialog   [modal]="true" [maximizable]="true" [(visible)]="ShowCreateApproval" [style]="{ width: '80%' }">
    <ng-template pTemplate="header">
      <h2>Create a new policy</h2>
    </ng-template>
    <div class="containersss">
      <p class="description">
        Set up and manage approval workflows for travel policies, including adding approvers,
        setting up sequential or parallel approvals, and defining approval conditions.
      </p>
    
      <div class="form-group">
        <label>Policy name</label>
        <input formControlName="policyName" placeholder="Enter the name of the policy" />
      </div>
    
      <div class="section">
        <h3>Approvers</h3>
        <p>You can add up to 10 approvers for each policy.</p>
        <button type="button" class="add-btn" (click)="addApprover()">+ Add approver</button>
        <div *ngFor="let approver of approvers.controls; let i = index">
          <input [formControl]="approver" placeholder="Approver {{ i + 1 }}" />
        </div>
      </div>
    
      <div class="section">
        <h3>Approval workflow</h3>
        <p>Choose your approval workflow.</p>
        <div class="workflow-options">
          <mat-radio-group
          [(ngModel)]="selectedWorkflow"
          class="workflow-options"
          name="workflow"
        >
          <mat-radio-button color="primary"
            *ngFor="let option of workflowOptions"
            [value]="option"
            class="workflow-option"
          >
            {{ option }}
          </mat-radio-button>
        </mat-radio-group>
        </div>
      </div>
    
      <div class="section">
        <h3>Approval conditions</h3>
        <p>You can create conditional approvals based on request attributes.</p>
        <button type="button" class="add-btn" (click)="addCondition()">+ Add condition</button>
        <div *ngFor="let condition of conditions.controls; let i = index">
          <input [formControl]="condition" placeholder="Condition {{ i + 1 }}" />
        </div>
      </div>
    
      <button class="save-btn" (click)="savePolicy()">Save policy</button>
    </div>
    
 
  <ng-template pTemplate="footer">
    <div class="flex justify-content-end gap-2 mt-3">
<!--       
    
      <p-button  label="Accept"  />&nbsp;
      <p-button  label="Back to Search"    /> -->

  </div>
  
  </ng-template>
</p-dialog>
  
 
                   